

import img1 from '../images/product/product1.jpg'
import img2 from '../images/product/product27.jpg'
import img3 from '../images/product/product28.jpg'
import img4 from '../images/product/product29.jpg'
import img5 from '../images/product/product31.jpg'
import img6 from '../images/product/product30.jpg'
import img7 from '../images/product/product51.jpg'
import img8 from '../images/product/product52.jpg'
import img9 from '../images/product/product53.jpg'
import img10 from '../images/product/product54.jpg'
import img11 from '../images/product/product55.jpg'
import img12 from '../images/product/product56.jpg'
import img13 from '../images/product/product57.jpg'
import img14 from '../images/product/product51.jpg'

import avt1 from '../images/author/author1.png'
import avt2 from '../images/author/author1.png'
import avt3 from '../images/author/author14.png'
import avt4 from '../images/author/author15.png'
import avt5 from '../images/author/author16.png'
import avt6 from '../images/author/author17.png'

const dataLiveaution = [
    {
        id: 1,
        img: img1,
        title: 'Amazon Gift Card',
        create: 'Magnus Perry',
        price : '₹500',
        avt : avt1,
    },
    {
        id: 2,
        img: img2,
        title: 'Google Play Card',
        create: 'Frederick Dixon',
        price : '₹500',
        avt : avt2,
    },
    {
        id: 3,
        img: img3,
        title: 'Apple Gift Card',
        create: 'Theo Watts',
        price : '₹500',
        avt : avt3,
    },
    {
        id: 4,
        img: img4,
        title: 'Flipkart Voucher',
        create: 'Neville Gutierrez',
        price : '₹500',
        avt : avt4,
    },
    {
        id: 5,
        img: img5,
        title: 'Myntra Gift Card',
        create: 'Frederick Dixon',
        price : '₹500',
        avt : avt5,
    },
    {
        id: 6,
        img: img6,
        title: 'Swiggy Voucher',
        create: 'Stephan Neal',
        price : '₹500',
        avt : avt6,
    },
    {
        id: 7,
        img: img7,
        title: 'Amazon Gift Card',
        create: 'Magnus Perry',
        price : '₹500',
        avt : avt1,
    },
    {
        id: 8,
        img: img8,
        title: 'Google Play Card',
        create: 'Frederick Dixon',
        price : '₹500',
        avt : avt2,
    },
    {
        id: 9,
        img: img9,
        title: 'Apple Gift Card',
        create: 'Theo Watts',
        price : '₹500',
        avt : avt3,
    },
    {
        id: 10,
        img: img10,
        title: 'Flipkart Voucher',
        create: 'Neville Gutierrez',
        price : '₹500',
        avt : avt4,
    },
    {
        id: 11,
        img: img11,
        title: 'Myntra Gift Card',
        create: 'Frederick Dixon',
        price : '₹500',
        avt : avt5,
    },
    {
        id: 12,
        img: img12,
        title: 'Swiggy Voucher',
        create: 'Stephan Neal',
        price : '₹500',
        avt : avt6,
    },
    {
        id: 13,
        img: img13,
        title: 'Myntra Gift Card',
        create: 'Frederick Dixon',
        price : '₹500',
        avt : avt5,
    },
    {
        id: 14,
        img: img14,
        title: 'Swiggy Voucher',
        create: 'Stephan Neal',
        price : '₹500',
        avt : avt6,
    },

    
   
]

export default dataLiveaution;